import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AddUserModel } from 'src/app/models/user/addUser.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {
  userRoles: any[];
  addUser: AddUserModel;
  Loader: boolean = false;
  userSelectedRoleId: string;

  constructor(private localstorage: LocalstorageService, private alertify: AlertifyService, private router: Router, private _userService: UserService) {
    this.localstorage.setMenu("2");
    this.addUser = new AddUserModel();
  }

  ngOnInit() {
    this.getUserRoles();
  }

  getUserRoles() {
    this._userService.userRoles().subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.userRoles = responseBody.responseData;
      }
    });
  }
  selectRole(selectedUser) {
    if (selectedUser != undefined && selectedUser != null && selectedUser != "") {
      var userFound = this.userRoles.filter((user) => {
        if (user.roleId == Number(selectedUser)) {
          return user;
        }
      });
      if (userFound.length > 0) {
        this.userSelectedRoleId = userFound[0].roleId.toString();
      }
    }
  }

  addUserData() {
    if (this.addUser.FirstName == undefined || this.addUser.FirstName == null || this.addUser.FirstName == "") {
      this.alertify.error("First Name is required");
      return;
    }
    if (this.addUser.LastName == undefined || this.addUser.LastName == null || this.addUser.LastName == "") {
      this.alertify.error("Last Name is required");
      return;
    }
    if (this.addUser.Email == undefined || this.addUser.Email == null || this.addUser.Email == "") {
      this.alertify.error("Email is required");
      return;
    }
    if (this.addUser.Password == undefined || this.addUser.Password == null || this.addUser.Password == "") {
      this.alertify.error("Password is required");
      return;
    }
    if (this.addUser.PhoneNumber == undefined || this.addUser.PhoneNumber == null || this.addUser.PhoneNumber == "") {
      this.alertify.error("Password is required");
      return;
    }
    this.Loader = true;
    this.addUser.UserType = this.userSelectedRoleId;
    this._userService.addUser(this.addUser).subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.addUser = new AddUserModel();
        this.alertify.success(responseBody.responseMessage);
        this.Loader = false;
        this.router.navigate(['userListing']);
      } else {
        this.alertify.error(responseBody.responseMessage);
        this.Loader = false;
      }
    });
  }
}
